export const CHANGE_SEARCH_FIELD: string = "CHANGE_SEARCH_FIELD";

export const SET_ROBOT_SET_FIELD: string = "SET_ROBOT_SET_FIELD";

export type RobotSet = "set1" | "set2" | "set3" | "set4";

export interface ISearchState {
  searchField: string;
  set: RobotSet;
}

export interface ISetSearchFieldAction {
  type: typeof CHANGE_SEARCH_FIELD;
  payload: string;
}

export interface IRobotSetFieldAction {
  type: typeof SET_ROBOT_SET_FIELD;
  payload: RobotSet;
}

export type SearchActionTypes = ISetSearchFieldAction | IRobotSetFieldAction;
